<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="container-fluid">
  <dl class="row">
    <div class="container">
      <div class="dialog-title">Edit Hunt</div>
      <form
        class="k-form"
        [formGroup]="formGroup"
        autocomplete="off"
        (ngSubmit)="onSubmit()"
      >
        <kendo-formfield>
          <label for="name">Hunt Name*</label>
          <input id="name" formControlName="name" maxlength="50" kendoTextBox />
          <kendo-formerror>Error: Name is required</kendo-formerror>
        </kendo-formfield>
        <kendo-formfield>
          <label for="environments">Environments*</label>
          <kendo-multiselect
            [data]="environments"
            textField="name"
            valueField="id"
            placeholder="Environments"
            formControlName="environments"
            (removeTag)="removeTag($event)"
            (valueChange)="onValueChange($event)"
          >
          </kendo-multiselect>
          <kendo-formerror>Error: Environment is required</kendo-formerror>
        </kendo-formfield>
        <div class="k-two-col">
          <kendo-formfield>
            <label for="priority">Priority</label>
            <kendo-dropdownlist
              value="{{ hunt.priority }}"
              [valuePrimitive]="true"
              formControlName="priority"
              [data]="priorities"
            >
            </kendo-dropdownlist>
          </kendo-formfield>
          <kendo-formfield>
            <label for="assignee">Assignee</label>
            <kendo-dropdownlist
              textField="fullName"
              valueField="id"
              formControlName="assignee"
              [data]="assignees$ | async"
            >
            </kendo-dropdownlist>
          </kendo-formfield>
        </div>
        <button
          themeColor="primary"
          class="dialog-button"
          size="large"
          type="submit"
          [disabled]="!formGroup.valid"
          kendoButton
        >
          Save
        </button>
      </form>
    </div>
  </dl>
</div>
